import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { Dropdown } from "../../../../dropdown";
import { Input } from "../../../../input";
import { InputStyleContext } from "../../../../input/context/InputStyleProvider";
import InputLoader from '../../InputLoader';
const Container = styled.div `
	display: flex;
	flex-direction: row;
	gap: 12px;
`;
const timeOptions = (connectorType) => {
    if (connectorType === 'exactly') {
        return [
            {
                label: 'day(s)',
                value: 'days',
            },
        ];
    }
    else {
        return [
            {
                label: 'day(s)',
                value: 'days',
            },
            { label: 'minute(s)', value: 'minutes' },
            { label: 'hour(s)', value: 'hours' },
        ];
    }
};
const InTheLast = ({ val, onChange, errors, isLoading, disabled, connectorType, }) => {
    var _a, _b;
    const [options, setOptions] = useState(timeOptions(connectorType));
    const time = (_a = val === null || val === void 0 ? void 0 : val[1]) !== null && _a !== void 0 ? _a : 'days';
    const num = (_b = val === null || val === void 0 ? void 0 : val[0]) !== null && _b !== void 0 ? _b : '1';
    useEffect(() => {
        var _a;
        const time = (_a = val === null || val === void 0 ? void 0 : val[1]) !== null && _a !== void 0 ? _a : 'days';
        setOptions((prev) => prev.map((op) => (Object.assign(Object.assign({}, op), { selected: time === op.value }))));
    }, [val]);
    useEffect(() => {
        var _a;
        if (typeof (val === null || val === void 0 ? void 0 : val[0]) === 'undefined') {
            const time = (_a = val === null || val === void 0 ? void 0 : val[1]) !== null && _a !== void 0 ? _a : 'days';
            onChange === null || onChange === void 0 ? void 0 : onChange(['1', time]);
        }
    }, []);
    if (isLoading) {
        return (_jsx("div", Object.assign({ style: { width: 200 } }, { children: _jsx(InputLoader, { containerStyle: { padding: '5px 8px' } }) })));
    }
    return (_jsx(InputStyleContext.Provider, Object.assign({ value: {
            InputWrapper: {
                width: 104,
            },
        } }, { children: _jsxs(Container, { children: [_jsx(Input, { type: "number", variant: "small", state: disabled ? 'disabled' : 'none', errorMessage: errors === null || errors === void 0 ? void 0 : errors.val, value: num, onChangeText: (text) => onChange === null || onChange === void 0 ? void 0 : onChange([text, time]) }), _jsx(Dropdown, { disabled: disabled, placeHolder: "Time", width: "108px", size: "small", options: options, onSelect: (option) => {
                        onChange === null || onChange === void 0 ? void 0 : onChange([num, option.value]);
                    } })] }) })));
};
const InTheLastWrapper = (props) => (_jsx(InTheLast, Object.assign({}, props)));
export default InTheLastWrapper;
//# sourceMappingURL=InTheLast.js.map